<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-02-28 16:17:10
 * @LastEditors: liulipeng liulipeng@longfor.com
 * @LastEditTime: 2026-01-12 16:39:23
 * @FilePath: /qd-c4-yunjing-web/src/views/oss/alarm/detail.vue
 * @Description: 这是默认设置,请设置`customMade`,
-->
<template>
  <div
    v-loading="loading"
    class="maia-content"
  >
    <el-row>
      <el-col :span="24">
        <ul class="detail-msg-wrap">
          <li>
            <p>告警时间：</p>
            <p>{{ formatDate( detailData.alarmTime ) }}</p>
          </li>
          <li>
            <p>告警源：</p>
            <p>{{ detailData.alarmSource }}</p>
          </li>
          <li>
            <p>告警描述：</p>
            <p>{{ detailData.alarmDesc }}</p>
          </li>
          <li>
            <p>告警源状态：</p>
            <p>{{ detailData.srcState==='alarm'?'异常':"正常" }}</p>
          </li>
          <li v-if="detailData.normalTime">
            <p>恢复时间：</p>
            <p>{{ formatDate(detailData.normalTime ) }}</p>
          </li>
          <li v-if="detailData.normalDesc">
            <p>恢复信息：</p>
            <p>{{ detailData.normalDesc }}</p>
          </li>
          <li>
            <p>子系统：</p>
            <p>{{ detailData.sysDictName }}</p>
          </li>
          <li>
            <p>设备类型：</p>
            <p>{{ detailData.deviceTypeName }}</p>
          </li>
          <li>
            <p>设备位置：</p>
            <p>{{ detailData.location }}</p>
          </li>
          <template v-if="technicalInfo">
            <li>
              <p>alarmId：</p>
              <p>
                {{ detailData.alarmId }}<span
                  class="copy-btn"
                  @click="copyCurrentMsg(detailData.alarmId)"
                >
                  复制
                </span>
              </p>
            </li>
            <li>
              <p>pointId：</p>
              <p>
                {{ detailData.sensorId }}<span
                  class="copy-btn"
                  @click="copyCurrentMsg(detailData.sensorId)"
                >
                  复制
                </span>
              </p>
            </li>
            <li>
              <p>slotPath：</p>
              <p>
                {{ detailData.path }}<span
                  class="copy-btn"
                  @click="copyCurrentMsg(detailData.path)"
                >
                  复制
                </span>
              </p>
            </li>
          </template>
          <li class="center">
            <el-button
              v-if="!technicalInfo"
              type="text"
              @click="technicalInfo = true"
            >
              显示点位技术信息
            </el-button>
          </li>
          <el-divider />
          <div class="two-row-wrap">
            <li>
              <p>工单发送状态：</p>
              <p>{{ statusToTxt(detailData.processStatus) }}</p>
            </li>
            <li>
              <p>工单发送时间：</p>
              <p v-if="detailData.processTime">{{ formatDate(detailData.processTime) }}</p>
              <p v-else> - </p>
            </li>
          </div>
          <div
            v-if="detailData.processStatus === 0 || detailData.processStatus === 2 || detailData.processStatus === 5"
            class="two-row-wrap"
          >
            <li>
              <p>未发送原因：</p>
              <p>{{ detailData.orderSendDetail || '-' }}</p>
            </li>
          </div>

          <!-- OSS订单信息 -->
          <div
            v-if="detailData.orderCode "
            class="two-row-wrap"
          >
            <li v-if="detailData.orderCode">
              <p>工单编号：</p>
              <p>{{ detailData.orderCode }}</p>
            </li>
            <li>
              <p>工单状态：</p>
              <p v-if="orderTimelineDetail&&orderTimelineDetail.length > 0">
                {{ orderTimelineDetail[orderTimelineDetail.length-1].followStatusName }}
              </p>
              <!-- <p>{{ orderStatusTxt(detailData.orderStatus ) }}</p> -->
            </li>
          </div>

          <li v-if="orderTimelineDetail&&orderTimelineDetail.length > 0">
            <p>工单处理过程：</p>
            <p><order-timeline :order-list="orderTimelineDetail" /></p>
          </li>
        </ul>
      </el-col>
    </el-row>
  </div>
</template>
<script setup lang="ts">
  import {
    ref, reactive, watch, computed,
    onMounted,
    nextTick,
  } from 'vue';
  import {
    getOrderFollowDetails, alarmDetail, getAlarmFilters,
  } from '@/api/modules/alarm';
  import { ElMessage } from 'element-plus';
  import { formatDate } from '@/utils/index';
  import { useOrgStore } from '@/store/org';
  import OrderTimeline from './order-line.vue';
  import {
    PROCESS_OPTIONS,
  } from './constants';

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    },
    flag: {
      type: [String, Number],
      default: 0,
    },
  });

  const loading = ref(false);
  const detailData = ref<TypeObject>({});
  const orderTimelineDetail:any = ref([]);
  const technicalInfo = ref<boolean>(false);
  const orgStore = useOrgStore();
  const currentOrgId = computed(() => orgStore.currentOrgInfo.orgId);

  const processStatusOptions = ref([...PROCESS_OPTIONS].map((item) => ({
    code: item.value,
    name: item.label,
  })));
  const copyCurrentMsg = (msg:string) => {
    if (msg) {
      const oInput = document.createElement('input');
      oInput.value = msg;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      document.body.removeChild(oInput);
      ElMessage.success('复制成功');
    }
  };
  /**
   * @description: 获取工单时间线信息
   */
  const getOrderTimelineDetail = (orderCode:string) => {
    loading.value = true;
    getOrderFollowDetails({
      orderCode,
    }).then((res) => {
      if (res.code === 0) {
        orderTimelineDetail.value = res.data.list || [];
      }
    }).catch().finally(() => { loading.value = false; });
  };

  const orderStatusTxt = (status:any) => {
    let txt = '-';
    switch (status * 1) {
    case 0:
      txt = '未处理';
      break;
    case 1:
      txt = '已生成';
      break;
    case 2:
      txt = '处理中 ';
      break;
    case 3:
      txt = '已完成 ';
      break;
    case 4:
      txt = '已关闭 ';
      break;
    default:
      break;
    }
    return txt;
  };

  const statusToTxt = (status:number) => (processStatusOptions.value.find((item) => Number(item.code) === status)?.name
    || '-');

  const getAlarmFiltersData = () => {
    getAlarmFilters({
      orgId: currentOrgId.value,
      alarmScope: 1,
      bizSource: '',
    }).then((res) => {
      const data = res.data;
      if (data && data.processStatusList && data.processStatusList.length > 0) {
        processStatusOptions.value = data.processStatusList;
      }
    });
  };
  /*
   * const getDetail = () => {
   *   alarmDetail({
   *     id: props.data.id,
   *     flag: props.flag,
   *   }).then((res) => {
   *     if (res.code === 0) {
   *       loading.value = false;
   *       detailData.value = res.data || {};
   *       if (detailData.value.orderCode) {
   *         getOrderTimelineDetail(detailData.value.orderCode);
   *       } // 有工单信息
   *     }
   *   }).catch().finally(() => {
   *     loading.value = false;
   *   });
   * };
   */
  onMounted(() => {
    // 获取工单发送状态选项
    getAlarmFiltersData();
    // getDetail()
    detailData.value = props.data;
    if (props.data.orderCode) {
      getOrderTimelineDetail(detailData.value.orderCode);
    }
  });
  </script>

  <style lang="scss" scoped>

.center {
  justify-content: center;
}

.two-row-wrap {
  display: flex;
  justify-content: space-between;

  li {
    flex: 1;
  }
}

.detail-msg-wrap {
  max-height: 500px;
  overflow-y: auto;

  li {
    display: flex;
    box-sizing: border-box;
    padding: 3px;
    line-height: 20px;

    p:nth-child(1) {
      flex: 0 0 130px;
      margin-right: 10px;
      text-align: right;
    }

    p:nth-child(2) {
      flex: 1;
      margin-left: 10px;
    }

    >div:nth-child(2) {
      flex: 1;
      margin-left: 10px;
    }

    .copy-btn {
      margin-left: 10px;
      color: #409EFF;
      cursor: pointer;
    }
  }

  .split-line {
    margin: 15px;
    background-color: #ececec;
  }
}

</style>
